var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSport = function SvgSport(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M11.4534 3.5C10.3134 3.5 8.95337 3.93333 8.95337 6V10C8.95337 12.0667 10.3134 12.5 11.4534 12.5C12.5934 12.5 13.9534 12.0667 13.9534 10V6C13.9534 3.93333 12.5934 3.5 11.4534 3.5Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M4.54663 3.5C3.40663 3.5 2.04663 3.93333 2.04663 6V10C2.04663 12.0667 3.40663 12.5 4.54663 12.5C5.68663 12.5 7.04663 12.0667 7.04663 10V6C7.04663 3.93333 5.68663 3.5 4.54663 3.5Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.9533 7.5H7.04663V8.5H8.9533V7.5Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15 10.1668C14.7267 10.1668 14.5 9.94016 14.5 9.66683V6.3335C14.5 6.06016 14.7267 5.8335 15 5.8335C15.2733 5.8335 15.5 6.06016 15.5 6.3335V9.66683C15.5 9.94016 15.2733 10.1668 15 10.1668Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1 10.1668C0.726667 10.1668 0.5 9.94016 0.5 9.66683V6.3335C0.5 6.06016 0.726667 5.8335 1 5.8335C1.27333 5.8335 1.5 6.06016 1.5 6.3335V9.66683C1.5 9.94016 1.27333 10.1668 1 10.1668Z",
    fill: "currentColor"
  })));
};
export default SvgSport;